module.exports = __webpack_public_path__ + "img/cash-voucher.1ba9cc55.png";